module.exports = require('../../full/object');



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/features/object/index.js
// module id = 387
// module chunks = 2